import type { DynamicDropdownMap } from '../models/dynamicDropdowns.types'
import { parseDynamicDropdownsResponse } from '../models/dynamicDropdowns.wire'

import { controllerHttp, decodeDto } from '@/shared/http'

export class DynamicDropdownsApi {
  constructor(private readonly controller: Pick<typeof controllerHttp, 'get'> = controllerHttp) {}

  async fetchDropdowns(
    url: string,
    query: string,
    signal?: AbortSignal,
  ): Promise<DynamicDropdownMap> {
    const response = await this.controller.get<unknown>(`${url}?${query}`, {
      suppressGlobalErrorHandler: true,
      meta: { suppressGlobalErrorHandler: true, retry: false },
      ...(signal ? { signal } : {}),
    })
    return decodeDto(response.data, parseDynamicDropdownsResponse)
  }
}

export const dynamicDropdownsApi = new DynamicDropdownsApi()
